export class User {
	public userId: any;
	public id: string;
	public _id?: string;
	public empresa: string;
	public cif_nif: string;
	public email: string;
	public password: string;
	public password2?: string;
	public nombre: string;
	public apellidos: string;
	public numCliRivisa: string;
	public idioma: string;
	public estado: any;
	public rol: number;
	public lastProjects?: any[];
	public projects?: number;
}
